import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
// eslint-disable-next-line
import Container from "react-bootstrap/Container"; // Bootstrap Container
// eslint-disable-next-line
import Row from "react-bootstrap/Row"; // Bootstrap Row
// eslint-disable-next-line
import Col from "react-bootstrap/Col";

const baseUrl = process.env.REACT_APP_API_URL;

function Services() {
  const auth = localStorage.getItem("auth");
  const authJsonObject = JSON.parse(auth);

  const [allchecked, setAllChecked] = useState([]);
  const [selectedDrones, setSelectedDrones] = useState([]); // State for drone checkboxes
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  // eslint-disable-next-line 
  const [initialDataLoaded, setInitialDataLoaded] = useState(false); 

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = authJsonObject["token"];
        const response = await fetch(`${baseUrl}/currentuser`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (isMounted && result.profile) {
          const fetchedServices = result.profile["services"] || [];
          const fetchedDrones = result.profile["drones_do_you_have"] || []; // Fetch drones_do_you_have field

          setAllChecked(fetchedServices); // Pre-fill services
          setSelectedDrones(fetchedDrones); // Pre-fill drones
          setInitialDataLoaded(true);

          // Disable button if both services and drones are empty
          setIsButtonDisabled(fetchedServices.length === 0 && fetchedDrones.length === 0);
        } else {
          setInitialDataLoaded(true);
          setIsButtonDisabled(true);
        }
      } catch (error) {
        console.error(error);
        setInitialDataLoaded(true);
        setIsButtonDisabled(true);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  function handleChange(e) {
    if (e.target.checked) {
      setAllChecked([...allchecked, e.target.value]);
    } else {
      setAllChecked(allchecked.filter((item) => item !== e.target.value));
    }
    setIsButtonDisabled(allchecked.length === 0 && !e.target.checked && selectedDrones.length === 0);
  }

  function handleDroneChange(e) {
    if (e.target.checked) {
      setSelectedDrones([...selectedDrones, e.target.value]);
    } else {
      setSelectedDrones(selectedDrones.filter((drone) => drone !== e.target.value));
    }
    setIsButtonDisabled(allchecked.length === 0 && selectedDrones.length === 0 && !e.target.checked);
  }

  const postData = {
    email: authJsonObject.user["email"],
    allchecked: allchecked,
    selectedDrones: selectedDrones, // Include selected drones in post data
  };

  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const token = authJsonObject["token"];
      const response = await fetch(`${baseUrl}/services`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(postData),
      });

      if (response.ok) {
        navigate('/dronepayload');
      } else {
        console.error("Failed to submit data:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
<div className="services-wrapper">
  <div className="services-box">
    <h2 className="services-heading">What type of drones do you have?</h2>
    <div className="checkbox-list">
      {[
        { value: "Imagery-RGB", label: "Imagery-RGB" },
        { value: "LiDAR", label: "LiDAR" },
        { value: "Thermal", label: "Thermal" },
        { value: "Confined Space", label: "Confined Space" },
      ].map((drone) => (
        <div key={drone.value} className="service-checkbox">
          <input
            value={drone.value}
            type="checkbox"
            onChange={handleDroneChange}
            checked={selectedDrones.includes(drone.value)}
          />
          <span> {drone.label} </span>
        </div>
      ))}
    </div>
    <br />
    <h2 className="services-heading">Please choose the services you or your company offer.</h2>
    <div className="checkbox-list">
      {[
        { value: "Drone imagery collection", label: "Drone imagery collection" },
        { value: "LiDAR data collection", label: "LiDAR data collection" },
        { value: "Thermal data collection", label: "Thermal data collection" },
        { value: "Solar Panel Inspection", label: "Solar Panel Inspection" },
        { value: "Wind turbine Inspection", label: "Wind turbine Inspection" },
        { value: "Power line inspection and monitoring", label: "Power line inspection and monitoring" },
        { value: "Pipeline inspection and monitoring", label: "Pipeline inspection and monitoring" },
        { value: "Mining Inspection", label: "Mining Inspection" },
        { value: "Building Inspection", label: "Building Inspection" },
        { value: "Bridge Inspection", label: "Bridge Inspection" },
        { value: "Confined space Industrial drone Inspection", label: "Confined space Industrial drone Inspection " },
        { value: "Construction site inspection and monitoring", label: "Construction site inspection and monitoring" },
        { value: "Rail road inspection and monitoring", label: "Rail road inspection and monitoring" },
        { value: "Others", label: "Others" },
      ].map((service) => (
        <div key={service.value} className="service-checkbox">
          <input
            value={service.value}
            type="checkbox"
            onChange={handleChange}
            checked={allchecked.includes(service.value)}
          />
          <span> {service.label} </span>
        </div>
      ))}
    </div>
    <div className="button-container mt-4 text-center">
      <Button
        variant="primary"
        className="select-drone-payload-button"
        disabled={isButtonDisabled}
        onClick={handleSubmit}
      >
        Go to Step-3 <br />
        (Please provide the details)
      </Button>
    </div>
  </div>
</div>
  )}
  
export { Services };
